import questions from '../data/questions';

/**
 * Return random integer from 0 to given max number
 * @param { number } max: maxium number
 * @return { number } random integer
 */
function getRandomInt(max) {
  return Math.floor(Math.random() * (max + 1));
}

/**
 * Push a random question that doesn't have the given tag to given output
 * @param { string } tag
 * @param { array } questions
 * @param { array } output
 */
function findQuestion(tag, questionArray, output) {
  if (questionArray.length === 0) return;
  if (questionArray.length === 1) {
    output.push(questionArray[0]);
    return;
  }

  const max = questionArray.length - 1;
  const secondIndex = getRandomInt(max);

  if (questionArray[secondIndex].tag === tag) {
    findQuestion(tag, questionArray, output);
  } else {
    output.push(questionArray[secondIndex]);
    questionArray.splice(secondIndex, 1);
  }
}

/**
 * Return a set of random questions
 * @param { array } questions
 * @return { array } array of two question objects
 */
function getQuestionSet(questionArray) {
  const output = [];
  const max = questionArray.length - 1;
  const selectedQuestion = questionArray.splice(getRandomInt(max), 1)[0];

  output.push(selectedQuestion);
  findQuestion(selectedQuestion.tag, questionArray, output);

  return output;
}

/**
 * Return an array of quesiton sets
 * @return { array } question sets
 */
export default function getQuestionSets() {
  const clonedQuestions = questions.slice();
  const output = [];

  for (let i = 0; i < 9; i += 1) {
    output.push(
      getQuestionSet(clonedQuestions)
    );
  }

  return output;
}



// WEBPACK FOOTER //
// ./app/utils/question-handler.js